import { useQuery } from '@tanstack/react-query'
import {
  getCustomerDocuments,
  getCustomerDocument,
} from 'global-apis/nexus-service-document'
import { getCustomerImages } from 'global-apis/nexus-service-customer'
import { useParams } from 'react-router-dom'

const useDocuments = () => {
  const { customerId } = useParams<{ customerId: string }>()

  const { data, error, isLoading } = useQuery({
    queryKey: ['customerDocuments', customerId],
    queryFn: () => getCustomerDocuments(customerId),
    }
  )

  const { data: imagesData, error: imagesError } = useQuery({
    queryKey: ['customerImages', customerId],
    queryFn: () => getCustomerImages(customerId),
    }
  )

  const useDocumentUri = (documentId, customerId) => {
    return useQuery({
      queryKey: ['downloadDocument', documentId],
      queryFn: () => getCustomerDocument(customerId, documentId),
      enabled: false,
      }
    )
  }

  const contracts = filterAndAddFileName(data?.contractsMap?.[0] || [])
  const pickupReceipts = filterAndAddFileName(data?.pickupReceiptMap?.[0] || [])
  const insuranceCards = filterAndAddFileName(
    data?.insuranceCardsMap?.[0] || []
  )
  const autoPayAuthorizations = filterAndAddFileName(
    data?.autoPayAuthorizationsMap?.[0] || []
  )

  const images = imagesData?.imagesList?.length
    ? imagesData.imagesList
        .filter(image => image && typeof image === 'object')
        .map((image, index) => ({
          id: image.id || '',
          imageType: image.imageType || 99,
          data: image.data || '',
          uri: image.uri || '',
          presignedUri: image.presignedUri || '',
          fileName: image.uri ? extractFileNameFromUri(image.uri) : `Image ${index + 1}`,
        }))
    : []

  return {
    contracts,
    pickupReceipts,
    insuranceCards,
    autoPayAuthorizations,
    images,
    error: error || imagesError,
    isLoading,
    useDocumentUri,
  }
}

export default useDocuments

function extractFileNameFromUri(uri) {
  return uri.split('/').pop()
}

function filterAndAddFileName(inputArray) {
  const filteredObjects = inputArray?.filter(
    (item) => typeof item === 'object' && item !== null
  )

  return filteredObjects?.filter((obj) => {
    if (typeof obj === 'object' && obj.documentUri) {
      return {
        ...obj,
        fileName: extractFileNameFromUri(obj.documentUri),
      }
    }
  })
}
